export default __webpack_public_path__ + "static/media/ContactSupportModalArrow.9ad27d28.svg";